import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=e5ff80a6&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=e5ff80a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ff80a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5ff80a6')) {
      api.createRecord('e5ff80a6', component.options)
    } else {
      api.reload('e5ff80a6', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=e5ff80a6&scoped=true&", function () {
      api.rerender('e5ff80a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4HDnQ7pWvh0SR/JS/comp/SearchFilterTokens.vue"
export default component.exports